export const SUPPORTED_LOCALES = [
  "ar",
  "bg",
  "cs",
  "de",
  "en",
  "es",
  "fr",
  "hu",
  "it",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "tr",
  "uk",
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const FALLBACK_LOCALE: SupportedLocale = "nl";

export function isSupportedLocale(code: string): code is SupportedLocale {
  for (const locale of SUPPORTED_LOCALES) {
    if (locale === code) {
      return true;
    }
  }
  return false;
}

export function resolveSupportedLocale(code: string | null | undefined): SupportedLocale {
  const base = code?.split("-")[0]?.toLowerCase();
  if (base && isSupportedLocale(base)) {
    return base;
  }
  return FALLBACK_LOCALE;
}
